var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"info"},[_vm._v(" Your payment is being processed. This may take several minutes. Please wait... ")]),_c('div',{staticClass:"sheet-button"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.newPayment()}}},[_vm._v("Pay again")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }